'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AssignFieldModalFooter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function AssignFieldModalFooter(props) {
  var onCancel = props.onCancel,
      onAssign = props.onAssign,
      isAssignButtonDisabled = props.isAssignButtonDisabled;
  return _react2["default"].createElement('div', {
    className: 'rainbow-import-records-flow_step-three-assign-field-modal-footer'
  }, _react2["default"].createElement(_Button2["default"], {
    className: 'rainbow-import-records-flow_step-three-assign-field-modal-footer_cancel-button',
    label: 'Cancel',
    onClick: onCancel
  }), _react2["default"].createElement(_Button2["default"], {
    label: 'Assign',
    variant: 'brand',
    onClick: onAssign,
    disabled: isAssignButtonDisabled
  }));
}

AssignFieldModalFooter.propTypes = {
  onCancel: _propTypes2["default"].func,
  onAssign: _propTypes2["default"].func,
  isAssignButtonDisabled: _propTypes2["default"].bool
};
AssignFieldModalFooter.defaultProps = {
  onCancel: function onCancel() {},
  onAssign: function onAssign() {},
  isAssignButtonDisabled: false
};